import { HeadlineType } from '../resourceContentUtils';

interface ArticleHeadlineProps {
  headline: string;
  headlineType: HeadlineType;
  variant?: 'default' | 'help';
}

export const ArticleHeadline = ({
  headline,
  headlineType,
  variant = 'default',
}: ArticleHeadlineProps) => {
  if (variant === 'help') {
    switch (headlineType) {
      case 'h1':
        return (
          <h1 className="text-[clamp(1.5rem,2.1vw,2rem)] font-semibold mb-4 pt-6">
            {headline}
          </h1>
        );
      case 'h2':
        return (
          <h2 className="text-[clamp(1.375rem,1.8vw,1.75rem)] font-semibold mb-3 pt-6">
            {headline}
          </h2>
        );
      case 'h3':
        return (
          <h3 className="text-[clamp(1.125rem,1.35vw,1.375rem)] font-semibold mb-2 pt-6">
            {headline}
          </h3>
        );
      case 'h4':
        return <h4 className="text-lg font-semibold mb-2 pt-6">{headline}</h4>;
      default:
        return null;
    }
  }

  switch (headlineType) {
    case 'h1':
      return (
        <h1 className="text-lg font-medium mb-4 text-bold pt-6">{headline}</h1>
      );
    case 'h2':
      return (
        <h2 className="text-lg font-medium mb-3 text-bold pt-6">{headline}</h2>
      );
    case 'h3':
      return (
        <h3 className="text-lg font-medium mb-2 text-bold pt-6">{headline}</h3>
      );
    case 'h4':
      return (
        <h4 className="text-md font-medium mb-2 text-bold pt-6">{headline}</h4>
      );
    default:
      return null;
  }
};
